interface GetSizeProps<T> {
  isLargeBp: boolean
  isMediumBp: boolean
  lg: T
  md: T
  sm: T
}

/*
  A grid config is simply a mapping of configuration values (lg, md, sm) passed along with currently active breakpoint
  settings (isLargeBp, isMediumBp) and returns the current config value that matches the appropriate breakpoint.
  This mapping works mobile first which means that you only need to pass a sm config for it to be used for all breakpoints.
*/
export const getGridConfig = <T>({ isLargeBp, isMediumBp, lg, md, sm }: GetSizeProps<T>, isVerticalGutter = false): string => {
  const getConfig = (config: T): string | null => (config !== undefined ? String(config) : null)

  const lgStyle = getConfig(lg)
  const mdStyle = getConfig(md)
  const smStyle = getConfig(sm)

  const breakPoints = {
    lg: lgStyle ?? (!isVerticalGutter ? mdStyle ?? smStyle : ''),
    md: mdStyle ?? (!isVerticalGutter ? smStyle : ''),
    sm: smStyle,
  }

  if (isLargeBp) {
    return breakPoints.lg ?? ''
  }
  if (isMediumBp) {
    return breakPoints.md ?? ''
  }
  return breakPoints.sm ?? ''
}
